import React from "react"

export default function Arrows({ flip }) {
  return (
    <svg
      transform={`scale(${flip},1)`}
      width="62"
      height="59"
      viewBox="0 0 62 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M32.7831 58.468C48.919 58.468 61.9997 45.39 61.9997 29.2574C61.9997 13.1249 48.919 0.046875 32.7831 0.046875C16.6472 0.046875 3.56641 13.1249 3.56641 29.2574C3.56641 45.39 16.6472 58.468 32.7831 58.468Z"
          fill="#BDB3B7"
        />
        <path
          d="M29.5057 58.7102C45.6416 58.7102 58.7224 45.6322 58.7224 29.4996C58.7224 13.3671 45.6416 0.289062 29.5057 0.289062C13.3698 0.289062 0.289062 13.3671 0.289062 29.4996C0.289062 45.6322 13.3698 58.7102 29.5057 58.7102Z"
          stroke="#3B1A53"
          strokeMiterlimit="10"
        />
        <path
          d="M31.4809 42.0449C31.3517 42.0443 31.2275 41.9946 31.1335 41.9059L18.8296 29.6046C18.7373 29.5114 18.6855 29.3855 18.6855 29.2544C18.6855 29.1232 18.7373 28.9974 18.8296 28.9042L31.1335 16.6086C31.2273 16.5253 31.3494 16.4809 31.4749 16.4846C31.6004 16.4883 31.7197 16.5398 31.8084 16.6285C31.8972 16.7172 31.9487 16.8365 31.9524 16.9619C31.9561 17.0874 31.9117 17.2095 31.8283 17.3033L19.8776 29.2399L31.8283 41.2055C31.8969 41.2743 31.9436 41.3619 31.9624 41.4571C31.9813 41.5524 31.9716 41.6512 31.9344 41.7409C31.8973 41.8307 31.8344 41.9075 31.7537 41.9616C31.673 42.0156 31.5781 42.0446 31.4809 42.0449Z"
          fill="#3B1A53"
        />
        <path
          d="M39.819 42.0437C39.6894 42.0449 39.5646 41.995 39.4716 41.9048L27.1851 29.6034C27.0928 29.5102 27.041 29.3844 27.041 29.2532C27.041 29.1221 27.0928 28.9962 27.1851 28.903L39.489 16.6075C39.5338 16.5605 39.5877 16.5232 39.6474 16.4977C39.7072 16.4721 39.7714 16.459 39.8364 16.459C39.9013 16.459 39.9656 16.4721 40.0253 16.4977C40.085 16.5232 40.1389 16.5605 40.1838 16.6075C40.2757 16.6997 40.3273 16.8246 40.3273 16.9548C40.3273 17.085 40.2757 17.2099 40.1838 17.3021L28.2389 29.2387L40.1838 41.2043C40.2523 41.2731 40.299 41.3607 40.3179 41.456C40.3368 41.5513 40.3271 41.65 40.2899 41.7398C40.2528 41.8295 40.1899 41.9063 40.1092 41.9604C40.0284 42.0145 39.9335 42.0435 39.8364 42.0437H39.819Z"
          fill="#3B1A53"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="62" height="59" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
